import axios2 from '../api/axios';
export const productservices = {
    createproduct,
    editproduct,
    getspecificproduct,
    getbulkproduct,
    createingredient,
    getallingredient,
    createcomponent,
    getcomponents,
    editcomponent,
    getunits,
    editproductdetail,
    deleteproduct,
    getproductcomponent,
    createbillofmaterial,
    getbillofmaterial,
    getproductcomponent,
    createmulticomponent,
    deletecomponents,
    updatebillofmaterial,
    getcomponentsviasupplier,
    getproducttrackingdata,
      
//     createbillofmaterial,
    getbllofmaterialDetail,
    getsingleproduct,
    getsinglecomponents,
    getcomponentsalldata,
    getallproductlist, 
    deletebom,
    geteditdetail,
    getstockproduct,
    getCustomerData,
    getcategory,
    updatestatus,
    createcategory,
    editcategory,
    deletecategory,
    getproductnature,
    getShopifystockviaAdminapi
}

function createproduct(objdata){
    return axios2.post(`/createproduct`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function editproduct(objdata){
    return axios2.post(`/editproduct`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}
function deleteproduct(id){
     return axios2.get(`/deleteproduct?id=${id}`,((response)=>{
         return response;   
    })).catch((error)=>{
         console.log(error); 
    })   
 }
 function deletebom(id){
        return axios2.post(`/deletebom/${id}`,((response)=>{
          return response;   
     })).catch((error)=>{
          console.log(error); 
     })    
 }

 function deletecomponents(id){
     return axios2.post(`/deletecomponent`,id,((response)=>{
          return response;   
     })).catch((error)=>{
          console.log(error); 
     })  
 }


function editproductdetail(id){
     return axios2.get(`/editproductdetail?id=${id}`,((response)=>{
          return response;   
     })).catch((error)=>{
          console.log(error); 
     })  
}


function getspecificproduct(id){
    return axios2.get(`/getspecificproduct?id=${id}`,((response)=>{
         return response;   
    })).catch((error)=>{
         console.log(error); 
    })   
}

function getbulkproduct(page,pageSize){
    return axios2.get(`/getbulkproduct?page=${page}&limit=${pageSize}`,((response)=>{
         return response;   
    })).catch((error)=>{
         console.log(error); 
    })   
}

function getproducttrackingdata(page,pageSize, orderBy){
    return axios2.get(`/getproducttrackingdata?page=${page}&limit=${pageSize}&orderby=${orderBy}`,((response)=>{
         return response;   
    })).catch((error)=>{
         console.log(error); 
    })   
}

function getcomponentsalldata(){
        return axios2.get(`/getcomponentsalldata`,((response)=>{
         return response;   
    })).catch((error)=>{
         console.log(error); 
    })    
}

function createingredient(objdata){
    return axios2.post(`/createingredient`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}


function getallingredient(){
    return axios2.get(`/getallingredient`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function createcomponent(objdata){
     return axios2.post(`/createcomponent`,objdata,((response)=>{
          return response;   
     })).catch((error)=>{
          console.log(error); 
     })   
}


function editcomponent(objdata){
     return axios2.post(`/editcomponent`,objdata,((response)=>{
          return response;   
     })).catch((error)=>{
          console.log(error); 
     })   
}

function getcomponents(page,pageSize,type){
     return axios2.get(`/getcomponents?page=${page}&limit=${pageSize}&type=${type}`,((response)=>{
          return response;   
     })).catch((error)=>{
          console.log(error); 
     })   
}

function getcomponentsviasupplier(id){
     return axios2.get(`/getcomponentsviasupplier?supplierid=${id}`,((response)=>{
          return response;   
     })).catch((error)=>{
          console.log(error); 
     })   
}

function getunits(){
     return axios2.get(`/getunits`,((response)=>{
          return response;   
     })).catch((error)=>{
          console.log(error); 
     })  
}
function getproductcomponent(){
    return axios2.get(`/getproductcomponent`,((response)=>{
         return response;   
    })).catch((error)=>{
         console.log(error); 
    })   
}
function createmulticomponent(objdata){
     const formdata = new FormData();
     formdata.append('componentfile',objdata); 
     return axios2.post(`/createexcelcomponent`,formdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })  
}

function createbillofmaterial(objdata){
    return axios2.post(`/createbillofmaterial`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function updatebillofmaterial(objdata){
    return axios2.post(`/updatebillofmaterial`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getbillofmaterial(page,pageSize){
    return axios2.get(`/getbillofmaterial?page=${page}&limit=${pageSize}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getbllofmaterialDetail(id){
   return axios2.get(`/getDetail?id=${id}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function updatestatus(formdata){
    return axios2.post(`/updatestatus`,formdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })  
}

function geteditdetail(id){
   return axios2.get(`/geteditdetail?id=${id}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getsingleproduct(id=0){
    return axios2.get(`/getsingleproduct?id=${id}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}
function getsinglecomponents(id=0){
    return axios2.get(`/getsinglecomponents?id=${id}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getallproductlist(){
       return axios2.get(`/getallproductlist`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })    
}
function getstockproduct(page,pageSize){
    return axios2.get(`/getstockproduct?page=${page}&limit=${pageSize}`,((response)=>{
         return response;   
    })).catch((error)=>{
         console.log(error); 
    })   
}
function getCustomerData(){
     return axios2.get(`/getcustomerdata`, ((response)=>{
          return response;
     })).catch((error)=>{
          console.log(error);
     })
}

function getcategory(){
     return axios2.get('/getcategorydata', ((response) => {
          return response;
     })).catch((error) => {
          console.log(error);
     })
}

function createcategory(formdata){
      return axios2.post('/createcategory', formdata,((response) => {
          return response;
     })).catch((error) => {
          console.log(error);
     })  
}


function editcategory(formdata){
      return axios2.post('/editcategory', formdata,((response) => {
          return response;
     })).catch((error) => {
          console.log(error);
     })  
}

function deletecategory(id){
     return axios2.get(`/deletecategory?id=${id}`,((response) => {
          return response;
     })).catch((error) => {
          console.log(error);
     })   
}

function getproductnature(fromdata){
      return axios2.post(`/getproductnature`,fromdata,((response) => {
          return response;
     })).catch((error) => {
          console.log(error);
     })  
}

function getShopifystockviaAdminapi(inventryid){
     return axios2.get(`/getShopifystockviaAdminapi?inventryid=${inventryid}`,((response) => {
          return response;
     })).catch((error) => {
          console.log(error);
     })  
}




